import { CustomersData } from "../../reducers/customers";

import { APIAccounts } from "../../api";
import { SearchCustomersContextProps } from "../../context/SearchCustomersProvider";
// import { TActions } from "../../reducers/customers/";
import { customersActions } from "../../reducers/customers";

// eslint-disable-next-line import/prefer-default-export
export const getCustomer = async (
  searchCustomersContext: SearchCustomersContextProps,
  customerCount: number,
  hasExpired: () => void,
  customers: CustomersData,
  isIgnoreCheckAccess = false,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: (cb: any) => void,
  signal: AbortSignal,
  isExportCSV?: boolean
): Promise<CustomersData | null> => {
  const {
    limit,
    page,
    search,
    isShowLeads,
    relatedTables,
    sortBy,
    isShowActiveSubscription,
    isShowInactiveAccounts,
    isShowPassedEvaluations,
    isShowBanned,
    isShowAbandoned,
  } = searchCustomersContext;

  const data = {
    limit,
    page,
    contains: {
      ...search,
      email: search.email
        ?.replaceAll(",", " ")
        .split(" ")
        .filter((email: string) => !!email),
    },
    isShowLeads,
    relatedTables,
    sortBy,
    isShowActiveSubscription,
    isShowInactiveAccounts,
    isShowPassedEvaluations,
    isShowBanned,
    isShowAbandoned,
  };

  let accessToExportCsv = null;
  if (isExportCSV) {
    try {
      if (!isIgnoreCheckAccess) {
        accessToExportCsv = await APIAccounts.getAccountsCsvRequest();
      }

      data.page = 0;
      data.limit = customerCount;
    } catch (error) {
      console.error("error getting permissions to export csv", error);
      hasExpired();
    }
  }

  try {
    dispatch(customersActions.fetchRequest());
    const response = await APIAccounts.getAccountsRequest(data, signal);

    const customersData: CustomersData = response.data;
    if (isIgnoreCheckAccess || (isExportCSV && accessToExportCsv?.data?.isCanExport)) {
      dispatch(customersActions.fetchSuccess({ customers, sortParams: sortBy }));
      return customersData;
    }

    dispatch(customersActions.fetchRequest());
    dispatch(customersActions.fetchSuccess({ customers: customersData, sortParams: sortBy }));
  } catch (error) {
    const e = error as { code: string };
    if (e.code !== "ERR_CANCELED") {
      console.error("error fetching customers", e);
      dispatch(customersActions.fetchFailed());
      hasExpired();
    }
  }

  return null;
};
